import { render, staticRenderFns } from "./AxHead.vue?vue&type=template&id=664776a0&scoped=true&"
import script from "./AxHead.vue?vue&type=script&lang=js&"
export * from "./AxHead.vue?vue&type=script&lang=js&"
import style0 from "./AxHead.vue?vue&type=style&index=0&id=664776a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664776a0",
  null
  
)

export default component.exports